export default __webpack_public_path__ + "static/media/db.7bef2539.png";